<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Assinar Laudos</h4>
            <div class="alert alert-info">
              <i class="bx bx-info-circle me-2"></i>
              Página em desenvolvimento
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Assinar Laudos",
    meta: [{ name: "description", content: "Assinar laudos médicos" }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Assinar Laudos",
      items: [
        { text: "Médico", href: "/doctor" },
        { text: "Assinar Laudos", active: true },
      ],
    };
  },
};
</script>
